import React from 'react';
import {
  Box,
  Card,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
// import { format, intervalToDuration } from 'date-fns';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

class OverviewPosOffline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      sx_hidden: { display: 'none' },
      value: "1",
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {};

    let data = BackofficeReportsApi.getPosStatus(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  }

  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let locationSalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.pos) {
        Object.keys(this.state.saleslocation_list.pos).forEach(key => {
          let fData = this.state.saleslocation_list.pos[key];

          let p = {
            name: fData.name,
            lastOnline: new Date(Date.parse(fData.lastSeenOnline)).toLocaleString('ro-RO')
          };

          locationSalesList.push(p);
        });
      }
    }

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: '100%',
      width: '100%',
      tableLayout: 'fixed',
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.8rem',
          sm: '0.88rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.55,
        sm: 0.85,
      },
      px: {
        xs: 0.55,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const bodyCellSx = {
      py: {
        xs: 0.6,
        sm: 0.8,
      },
      px: {
        xs: 0.55,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
    };

    return (
      <Paper
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: '100%',
          },
          maxHeight: {
            xs: 600,
            sm: '100%',
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Card
          sx={{
            height: '100%',
            minHeight: 0,
            borderRadius: 0,
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              px: {
                xs: 0.75,
                sm: 1,
              },
              py: {
                xs: 0.65,
                sm: 0.85,
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              flexShrink: 0,
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                POS Offline
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Last seen online by POS
              </Typography>
            </Box>

            <Typography
              sx={{
                flexShrink: 0,
                color: locationSalesList.length > 0 ? '#b42318' : '#1a237e',
                bgcolor: locationSalesList.length > 0
                  ? 'rgba(180, 35, 24, 0.08)'
                  : 'rgba(26, 35, 126, 0.08)',
                border: locationSalesList.length > 0
                  ? '1px solid rgba(180, 35, 24, 0.14)'
                  : '1px solid rgba(26, 35, 126, 0.12)',
                borderRadius: 999,
                px: 1,
                py: 0.35,
                fontWeight: 800,
                fontSize: {
                  xs: '0.72rem',
                  sm: '0.78rem',
                },
                lineHeight: 1.2,
              }}
            >
              {locationSalesList.length} offline
            </Typography>
          </Box>

          <TableContainer sx={tableContainerSx}>
            <Table stickyHeader aria-label="pos offline table" sx={tableSx}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '52%',
                        sm: '55%',
                      },
                    }}
                  >
                    POS Offline
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      ...headerCellSx,
                      width: {
                        xs: '48%',
                        sm: '45%',
                      },
                    }}
                  >
                    Last Online
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? locationSalesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : locationSalesList
                ).map((location) => {
                  const dateParts = String(location.lastOnline || '').split(',');
                  const dateLine = dateParts[0] || '';
                  const timeLine = dateParts.slice(1).join(',').trim();

                  return (
                    <TableRow hover key={location.name} tabIndex={-1}>
                      <TableCell
                        sx={{
                          ...bodyCellSx,
                          fontWeight: 550,
                          fontSize: {
                            xs: '0.8rem',
                            sm: '0.88rem',
                          },
                        }}
                      >
                        {location.name}
                      </TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          ...bodyCellSx,
                          color: '#475569',
                          whiteSpace: 'normal',
                          lineHeight: 1.12,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            minWidth: 0,
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: {
                                xs: '0.78rem',
                                sm: '0.86rem',
                              },
                              fontWeight: 550,
                              lineHeight: 1.1,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '100%',
                            }}
                          >
                            {dateLine}
                          </Typography>

                          {timeLine && (
                            <Typography
                              component="span"
                              sx={{
                                fontSize: {
                                  xs: '0.7rem',
                                  sm: '0.76rem',
                                },
                                fontWeight: 500,
                                lineHeight: 1.1,
                                color: '#64748b',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%',
                              }}
                            >
                              {timeLine}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}

                {locationSalesList.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <Box
                        sx={{
                          py: 4,
                          color: 'text.secondary',
                          fontSize: {
                            xs: '0.86rem',
                            sm: '0.92rem',
                          },
                        }}
                      >
                        No offline POS
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
            labelRowsPerPage="Rows:"
            component="div"
            count={locationSalesList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            sx={paginationSx}
          />
        </Card>
      </Paper>
    );
  }
}

export default OverviewPosOffline;
